<template>
	<transition
			appear
			:appear-active-class="$_crdVd_styleCardVideoAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row no-gutters>
					<v-col class="center">
						<video
								class="video-js vjs-fluid customVideo"
								ref="videoPlayer"
								@click.right.prevent="$_crdVd_click()" />
					</v-col>
				</v-row>
				<template v-if="video_.ready">
					<v-row no-gutters>
						<v-col>
							<v-progress-linear
									class="linear_"
									height="24"
									:color="$_crdVd_videoProgressLinearColor"
									:value="$_crdVd_getCurrentPercentage()">
								<template v-slot="{ value }">
									<template v-if="!isFalse(value)">
										<v-row	align="center"
												justify="center"
												no-gutters>
											<v-col cols="auto">
												<span class="overline" v-text="$_crdVd_getCurrentTime()" />
											</v-col>
											<v-col cols="auto">
												<span class="overline">&nbsp;/&nbsp;</span>
											</v-col>
											<v-col cols="auto">
												<span class="overline" v-text="$_crdVd_getDurationTime()" />
											</v-col>
											<v-col cols="auto">
												<span class="overline">&nbsp;(&nbsp;</span>
											</v-col>
											<v-col cols="auto">
												<span class="overline" v-text="$_crdVd_getRemainingTime()" />
											</v-col>
											<v-col cols="auto">
												<span class="overline">&nbsp;)</span>
											</v-col>
										</v-row>
									</template>
								</template>
							</v-progress-linear>
						</v-col>
					</v-row>
				</template>
				<template v-if="isObject($_crdVd_videoButton)">
					<v-card-actions>
						<v-row dense>
							<template v-if="$_crdVd_videoButtonPlay">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_play()">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>play_circle_outline</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">play</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonPause">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_pause()">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>pause_circle_outline</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">pause</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonReplay">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_replay()">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>replay</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">replay</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonMinus5Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(-5)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>replay_5</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">- 5 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonMinus10Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(-10)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>replay_10</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">- 10 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonMinus30Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(-30)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>replay_30</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">- 30 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonPlus5Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(5)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>forward_5</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">+ 5 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonPlus10Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(10)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>forward_10</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">+ 10 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonPlus30Sec">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_currentTime(30)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>forward_30</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">+ 30 sec</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonHalfSpeed">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_playbackRate(0.5)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>speed</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">0.5 X</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonNormalSpeed">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_playbackRate(1)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>speed</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">1 X</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonTwiceSpeed">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_playbackRate(2)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>speed</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">2 X</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonMute">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_muted(true)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>volume_off</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">mute on</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
							<template v-if="$_crdVd_videoButtonUnmute">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_crdVd_styleVideoButtonBlock"
											:color="$_crdVd_styleVideoButtonColor"
											:dark="$_crdVd_styleVideoButtonDark"
											:depressed="$_crdVd_styleVideoButtonDepressed"
											:elevation="$_crdVd_styleVideoButtonElevation"
											:large="$_crdVd_styleVideoButtonLarge"
											:light="$_crdVd_styleVideoButtonLight"
											:outlined="$_crdVd_styleVideoButtonOutlined"
											:rounded="$_crdVd_styleVideoButtonRounded"
											:small="$_crdVd_styleVideoButtonSmall"
											:text="$_crdVd_styleVideoButtonFlat"
											@click="$_crdVd_muted(false)">
										<v-row align="center" dense>
											<v-col cols="auto">
												<v-icon>volume_up</v-icon>
											</v-col>
											<v-col cols="auto">
												<span class="overline">mute off</span>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>
							</template>
						</v-row>
					</v-card-actions>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CardVideo',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				video_: {
					duration: 0,
					ended: false,
					ready: false
				},
				player_: null
			}
		},
		computed: {
			// info
			// (content)
			$_crdVd_video() {
				const self_ = this;
				return self_.contents[self_.contentKey].video
			},
			$_crdVd_videoAutoPlay() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return video_.autoPlay
			},
			$_crdVd_videoControls() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return video_.controls
			},
			$_crdVd_videoProgressLinearColor() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return video_.progressLinearColor
			},
			$_crdVd_videoMuted() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return video_.muted
			},
			$_crdVd_videoLoadingImage() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return self_.getStylesVal(video_.loadingImage)
			},
			$_crdVd_videoReadyImage() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return self_.getStylesVal(video_.readyImage)
			},
			$_crdVd_videoUrl() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return self_.getStylesVal(video_.url)
			},
			// (content - videoButton)
			$_crdVd_videoButton() {
				const self_ = this;
				const video_ = self_.$_crdVd_video;
				return video_.videoButton
			},
			$_crdVd_videoButtonPlay() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.play
			},
			$_crdVd_videoButtonPause() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.pause
			},
			$_crdVd_videoButtonReplay() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.replay
			},
			$_crdVd_videoButtonMinus5Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.minus5Sec
			},
			$_crdVd_videoButtonMinus10Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.minus10Sec
			},
			$_crdVd_videoButtonMinus30Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.minus30Sec
			},
			$_crdVd_videoButtonPlus5Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.plus5Sec
			},
			$_crdVd_videoButtonPlus10Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.plus10Sec
			},
			$_crdVd_videoButtonPlus30Sec() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.plus30Sec
			},
			$_crdVd_videoButtonHalfSpeed() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.halfSpeed
			},
			$_crdVd_videoButtonNormalSpeed() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.normalSpeed
			},
			$_crdVd_videoButtonTwiceSpeed() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.twiceSpeed
			},
			$_crdVd_videoButtonMute() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.mute
			},
			$_crdVd_videoButtonUnmute() {
				const self_ = this;
				const button_ = self_.$_crdVd_videoButton;
				if(self_.isEmpty(button_)) { return false }
				return button_.unmute
			},
			// style
			$_crdVd_styleCardVideo() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'cardVideo')
				}
			},
			$_crdVd_styleCardVideoAnimation() {
				const self_ = this;
				return () => {
					const video_ = self_.$_crdVd_styleCardVideo()
					if(self_.isFalse(video_)) { return null }
					return self_.getStylesVal(video_.animation)
				}
			},
			$_crdVd_styleVideoButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'videoButton')
			},
			$_crdVd_styleVideoButtonBlock() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_crdVd_styleVideoButtonColor() {
				const self_ = this;
				const button_ =self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_crdVd_styleVideoButtonDark() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_crdVd_styleVideoButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_crdVd_styleVideoButtonElevation() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_crdVd_styleVideoButtonFlat() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_crdVd_styleVideoButtonLarge() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_crdVd_styleVideoButtonLight() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_crdVd_styleVideoButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_crdVd_styleVideoButtonRounded() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_crdVd_styleVideoButtonSmall() {
				const self_ = this;
				const button_ = self_.$_crdVd_styleVideoButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		mounted() {
			const self_ = this;

			let controls_ = self_.env.dev || self_.$_crdVd_videoControls; // control is always on for dev env

			self_.player_ = self_.videojs(self_.$refs.videoPlayer, 
				{
					language: 'en',
					playbackRates: [0.7, 1.0, 1.5, 2.0],
					poster: self_.$_crdVd_videoLoadingImage,
					preload: 'metadata',

					autoplay: self_.$_crdVd_videoAutoPlay,
					controls: controls_,
					muted: self_.$_crdVd_videoMuted,
					sources: [{
						type: 'video/mp4',
						src: self_.$_crdVd_videoUrl
					}]
				}, 
				function onPlayerReady() {
					self_.video_.ready = true;
					self_.$emit('ready')

					self_.player_.on('ended', () => {
						self_.video_.ended = true;
						self_.$emit('ended')
					})

					self_.player_.on('loadedmetadata', () => {
						self_.video_.duration = self_.player_.duration()
						self_.player_.poster(self_.$_crdVd_videoReadyImage)
					})
				}
			)
		},
		beforeDestroy() {
			const self_ = this;

			if (self_.player) {
				self_.player.dispose()
			}
		},
		methods: {
			$_crdVd_click() {
				//
			},
			$_crdVd_play() {
				const self_ = this;
				self_.player_.play()
			},
			$_crdVd_pause() {
				const self_ = this;
				self_.player_.pause()
			},
			$_crdVd_replay() {
				const self_ = this;
				self_.player_.currentTime(0)
				self_.player_.play()
			},
			$_crdVd_currentTime(time) {
				const self_ = this;
				const current_ = self_.player_.currentTime()
				self_.player_.currentTime(current_ + time)
			},
			$_crdVd_playbackRate(rate) {
				const self_ = this;
				self_.player_.playbackRate(rate)
			},
			$_crdVd_muted(muted) {
				const self_ = this;
				self_.player_.muted(muted)
			},
			$_crdVd_getCurrentTime() {
				const self_ = this;

				const current_ = self_.player_.currentTime()

				const seconds_ = Math.floor(current_ ) % 60;
				const minutes_ = Math.floor(current_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			},
			$_crdVd_getCurrentPercentage() {
				const self_ = this;
				const current_ = self_.player_.currentTime()
				const duration_ = self_.video_.duration;
				return current_ / duration_ * 100
			},
			$_crdVd_getDurationTime() {
				const self_ = this;

				const duration_ = self_.video_.duration;

				const seconds_ = Math.floor(duration_ ) % 60;
				const minutes_ = Math.floor(duration_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			},
			$_crdVd_getRemainingTime() {
				const self_ = this;

				const current_ = self_.player_.currentTime()
				const duration_ = self_.video_.duration;
				const remaining_ = duration_ - current_

				const seconds_ = Math.floor(remaining_ ) % 60;
				const minutes_ = Math.floor(remaining_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			}
		}
	}
</script>

<style scoped>
	.linear_ {
		border-radius: 0 0 4px 4px;
	}
</style>
